
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface UserFormActionsProps {
  isSubmitting: boolean;
  onCancel?: () => void;
}

const UserFormActions = ({ isSubmitting, onCancel }: UserFormActionsProps) => {
  return (
    <div className="flex justify-end space-x-2 pt-2">
      {onCancel && (
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancelar
        </Button>
      )}
      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Criando...
          </>
        ) : (
          "Criar Usuário"
        )}
      </Button>
    </div>
  );
};

export default UserFormActions;
